<ng-container *ngIf="showInfo">
  <div
    class="approval-limit-info"
    [@approvalLimitInfo]
    *ngIf="{ count: approvedAssetCount$ | async } as approvedAssetCount"
  >
    <div class="progress-container" *ngIf="approvedAssetCount.count < (gallery.approval_limits | abs); else done">
      <app-circle-progress-bar
        [progress]="progress"
        [strokeWidth]="20"
        [size]="40"
        color="green"
      ></app-circle-progress-bar>
    </div>
    <ng-template #done>
      <div
        class="animated-circle-icon green"
        *ngIf="approvedAssetCount.count === (gallery.approval_limits | abs); else warning"
      >
        <app-svg src="/assets/icons/checkmark.svg"></app-svg>
      </div>
    </ng-template>
    <ng-template #warning>
      <div class="animated-circle-icon orange">
        <app-svg src="/assets/icons/alert-circle.svg"></app-svg>
      </div>
    </ng-template>

    <div class="approval-text">{{ approvedAssetCount.count }} of {{ gallery.approval_limits | abs }} Approved</div>
  </div>
</ng-container>
